import { render, staticRenderFns } from "./OnlineConsult.vue?vue&type=template&id=00903608&scoped=true"
import script from "./OnlineConsult.vue?vue&type=script&lang=js"
export * from "./OnlineConsult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00903608",
  null
  
)

export default component.exports